import script from "./ShareDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareDashboard.vue?vue&type=script&setup=true&lang=js"

import "./ShareDashboard.vue?vue&type=style&index=0&id=0d5141c8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d5141c8"]])

export default __exports__